import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon, AlertTriangleIcon } from 'lucide-react';
const symptoms = ['Falta de energía', 'Problemas digestivos', 'Caída excesiva de pelo', 'Alergias constantes', 'Mal aliento o problemas de piel'];
export function ProblemSection() {
  return <section className="py-12 md:py-16 px-4 bg-lightgreen" data-id="element-191">
      <div className="max-w-2xl mx-auto" data-id="element-192">
        {/* Inner card container */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white/80 backdrop-blur-sm rounded-3xl border border-sage/60 shadow-[0_4px_32px_rgba(0,0,0,0.06)] px-5 py-7 md:px-8 md:py-9" data-id="element-193">
          {/* Title */}
          <div className="text-center mb-6" data-id="element-194">
            <div className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-accent/10 mb-3" data-id="element-195">
              <AlertTriangleIcon className="w-5 h-5 text-accent" data-id="element-196" />
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-serif text-charcoal leading-tight mb-2" data-id="element-197">
              Tu perro podría estar{' '}
              <span className="text-primary text-[1.15em] font-extrabold uppercase tracking-wide" data-id="element-198">
                enfermando
              </span>
              <br data-id="element-199" />
              por lo que come...
            </h2>
            <p className="text-lg md:text-xl font-semibold text-accent" data-id="element-200">
              Y tú ni siquiera lo sabés
            </p>
            <div className="w-16 h-1 bg-accent mx-auto rounded-full mt-3" data-id="element-201"></div>
          </div>

          {/* Body Text */}
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.15
        }} className="mb-6 space-y-2.5 text-base md:text-lg text-gray-600 leading-snug text-center max-w-xl mx-auto" data-id="element-202">
            <div className="border border-primary/30 rounded-xl px-5 py-4 bg-transparent space-y-2.5" data-id="element-203">
              <p className="font-[800]" data-id="element-204">
                Tal vez notaste que tu perro ya no tiene la misma energía de
                antes...
              </p>
              <p data-id="element-205">
                Quizás duerme más, juega menos o simplemente no parece tan feliz
                como antes.
              </p>
            </div>
            <div className="pt-1" data-id="element-206">
              <p className="text-charcoal font-bold text-lg md:text-xl" data-id="element-207">
                Y lo peor...
              </p>
            </div>
            <p className="bg-[#FFFBF5]" data-id="element-208">
              👉Muchos dueños piensan que es normal.
            </p>
          </motion.div>

          {/* Symptoms List */}
          <div className="flex flex-col items-center gap-2 mb-7" data-id="element-209">
            {symptoms.map((symptom, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -15
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.35,
            delay: 0.25 + index * 0.08
          }} className="flex items-center gap-2.5 bg-red-50/50 rounded-xl border border-red-100 shadow-sm px-4 py-2.5 w-full max-w-sm" data-id="element-210">
                <XCircleIcon className="w-4 h-4 text-red-500 flex-shrink-0" data-id="element-211" />
                <span className="text-sm md:text-base font-medium text-gray-700" data-id="element-212">
                  {symptom}
                </span>
              </motion.div>)}
          </div>

          {/* Final Impact Message */}
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.6
        }} className="rounded-2xl border border-primary/20 px-5 py-5 md:px-6 md:py-6 max-w-xl mx-auto text-center bg-[#F8F6F3]" data-id="element-213">
            <p className="text-base md:text-lg text-gray-600 mb-2" data-id="element-214">
              👉Pero en muchos casos, el problema no es la edad...
            </p>
            <p className="text-lg md:text-xl font-extrabold text-primary leading-snug" data-id="element-215">
              Es la alimentación que recibe todos los días.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}